<template>
    <div class="text-block" :style="blockStyles">
        <div class="editor-container mb-2">
            <QuillEditor ref="quillEditor" v-model:content="localContent" content-type="html" :options="editorOptions"
                @blur="updateContent" @text-change="onContentChange" />
        </div>
    </div>
</template>

<script>
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css'

export default {
    name: 'TextBlock',
    components: {
        QuillEditor
    },
    props: {
        block: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            isEditing: false,
            localContent: '',
            editingTimeout: null,
            textAlignOptions: [
                { text: 'Gauche', value: 'left' },
                { text: 'Centre', value: 'center' },
                { text: 'Droite', value: 'right' },
                { text: 'Justifié', value: 'justify' }
            ],
            editorOptions: {
                theme: 'snow',
                modules: {
                    toolbar: [
                        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                        ['bold', 'italic', 'underline', 'strike'],
                        [{ 'color': [] }, { 'background': [] }],
                        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                        [{ 'indent': '-1' }, { 'indent': '+1' }],
                        [{ 'align': [] }],
                        ['link'],
                        ['clean']
                    ]
                },
                placeholder: 'Saisissez votre texte...'
            }
        }
    },
    computed: {
        blockStyles() {
            return {
                fontSize: this.block.styles?.fontSize || '16px',
                color: this.block.styles?.color || '#333333',
                textAlign: this.block.styles?.textAlign || 'left',
                lineHeight: this.block.styles?.lineHeight || '1.5',
                fontFamily: this.block.styles?.fontFamily || 'Arial, sans-serif'
            }
        },
        displayContent() {
            return this.block.content || '<p>Cliquez pour éditer le texte...</p>'
        }
    },
    mounted() {
        this.localContent = this.block.content || ''
        document.addEventListener('click', this.handleClickOutside)
    },

    beforeUnmount() {
        document.removeEventListener('click', this.handleClickOutside)
    },
    methods: {
        startEditing() {
            console.log('startEditing called') // Debug
            this.isEditing = true
            this.localContent = this.block.content || ''

            // Délai pour éviter le conflit avec handleClickOutside
            this.editingTimeout = setTimeout(() => {
                this.$nextTick(() => {
                    if (this.$refs.quillEditor) {
                        this.$refs.quillEditor.focus()
                    }
                })
            }, 100)
        },

        updateContent() {
            console.log('updateContent called') // Debug
            if (this.editingTimeout) {
                clearTimeout(this.editingTimeout)
                this.editingTimeout = null
            }
            this.isEditing = false
            this.$emit('update', {
                content: this.localContent
            })
        },

        onContentChange() {
            // Mise à jour en temps réel pour l'aperçu
            this.$emit('update', {
                content: this.localContent
            })
        },

        updateStyles() {
            this.$emit('update', {
                styles: { ...this.block.styles }
            })
        },

        handleClickOutside(event) {
            // Ignorer si on vient de commencer l'édition
            if (this.editingTimeout) {
                clearTimeout(this.editingTimeout)
                this.editingTimeout = null
                return
            }

            if (this.isEditing && !this.$el.contains(event.target)) {
                this.updateContent()
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.editor-container {
    .ql-editor {
        min-height: 100px;
        font-size: 14px;
        line-height: 1.5;
    }

    .ql-toolbar {
        border-top: 1px solid #ccc;
        border-left: 1px solid #ccc;
        border-right: 1px solid #ccc;
        border-radius: 4px 4px 0 0;
    }

    .ql-container {
        border-bottom: 1px solid #ccc;
        border-left: 1px solid #ccc;
        border-right: 1px solid #ccc;
        border-radius: 0 0 4px 4px;
    }
}
</style>
